import { useState } from "react";

export default function ExerciseViewer({ pdfAssetPath, isFullscreen, onFullscreen, onExitFullscreen, onDownload, onPrint, onReady }) {
  const [ready, setReady] = useState(false);
  const controls = (
    <div className="exercise-viewer-controls" data-testid="exercise-viewer-controls">
      {isFullscreen ? (
        <button type="button" onClick={onExitFullscreen} data-testid="exercise-exit-fullscreen">Exit Full Screen</button>
      ) : (
        <button type="button" onClick={onFullscreen} data-testid="exercise-fullscreen">Full Screen</button>
      )}
      <a href={pdfAssetPath} download onClick={onDownload} data-testid="exercise-download-pdf">Download PDF</a>
      <button type="button" onClick={onPrint} data-testid="exercise-print-pdf">Print</button>
    </div>
  );

  return (
    <section className={`exercise-viewer ${isFullscreen ? "exercise-viewer-fullscreen" : ""}`} data-testid="exercise-pdf-section">
      {controls}
      <iframe title="Exercise material" src={pdfAssetPath} onLoad={() => { setReady(true); onReady?.(); }} className={`exercise-pdf-frame ${ready ? "is-ready" : ""}`} data-testid="exercise-pdf-viewer" />
    </section>
  );
}